<template>

  <div class="border-title title">
    <p class="title">환불계좌관리<span class="desc">H캐시 환불을 위한 계좌 정보를 등록하세요.</span></p>
  </div>
  <div class="box-gray inset40 mt40">
    <h4 class="title">환불계좌 안내</h4>
    <ul class="dot-list mt24">
      <li>환불계좌 등록/수정 시 계좌 인증 및 통장사본 업로드 후 승인 요청해 주시기 바랍니다.</li>
      <li>승인 요청 시 영업일 기준 최대 1일 이내 관리자가 계좌 정보 확인 후 승인 진행해 드립니다.</li>
      <li>회원님의 사업자 정보와 계좌 정보가 일치하지 않을 경우 승인이 거절될 수 있습니다.</li>
      <li>승인 요청 시 계좌 수정 불가하나, 승인 또는 승인 거절된 이후에는 계좌 수정 가능합니다.</li>
      <li>환불계좌 승인 후 H캐시 환불 신청 가능합니다.</li>
      <li>승인된 환불계좌가 휴면 등의 사유로 입금이 제한된 경우 환불금의 입금이 지연될 수 있습니다.</li>
      <!-- <li v-if="useHconAuthInfo().getIfPossible()?.userContext.hcBzcoDivCd == '1001'"><span class="text-red">식별번호란에 사업자등록번호를 입력해주세요. ( '-' 제외 )</span></li>
      <li v-if="useHconAuthInfo().getIfPossible()?.userContext.hcBzcoDivCd == '1002'"><span class="text-red">식별번호란에 생년월일(YYYYMMDD)을 입력해주세요.</span></li> -->
      <li><span class="text-red">개인사업자는 식별번호란에 생년월일(YYYYMMDD)을, 법인사업자는 식별번호란에 사업자등록번호를 입력해주세요. ( '-' 제외 )</span></li>
    </ul>
  </div>
  <AccoungManager @accountCheckResult="handleCheckAccount"  ref="accountManagerRef" :divCd="'1001'" v-model:file-value="bzcoRgcrt" v-model:account-value="accountForm" v-model:status="status"/>
  <div class="mt40" v-if="status == 'READY'">
    <div class="form-box">
      <!-- 에러 메시지 출력일 경우 form-group클래스에 error 추가 -->
      <div class="form-group row">
        <HconCheckBox :checked="checkBoxAgreeChecked =='Y' ? true : false" v-model="checkBoxAgree" @change="checkBoxAgreeChanged" type="default" label="개인정보 수집 및 이용에 동의합니다." name="allCheckBtn" labelClass="font-bold fs18 gap5" :showTextBefore="true" text="[필수]" textClass="text-red font-normal" :hide-label="false" required />
      </div>
    </div>
    <div class="box-border mt20 p33 scroll">
      <table class="tbl-type terms">
        <caption>개인정보 수집 및 이용 관련 표</caption>
        <colgroup>
          <col style="width:12%;">
          <col style="width:auto;">
        </colgroup>
        <thead>
          <tr>
            <th scope="col" class="small">구분</th>
            <th scope="col" class="small">내용</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>수집시기</td>
            <td class="left">환불계좌 등록 시</td>
          </tr>
          <tr>
            <td>수집항목</td>
            <td class="left">은행명, 환불계좌, 예금주명, 통장사본</td>
          </tr>
          <tr>
            <td>수집목적</td>
            <td class="left">환불계좌 등록 및 환불처리</td>
          </tr>
          <tr>
            <td>보유기간</td>
            <td class="left">회원탈퇴 후 30일 이내 또는 법령에 다른 보존기간</td>
          </tr>
        </tbody>
      </table>
      <ul class="dot-list mt16">
        <li>위와 같이 수집하는 정보에 대해 동의를 거부하실 수 있습니다. 단, 거부 시 환불계좌 등록 및 전용계좌 이용이 불가합니다.</li>
      </ul>
    </div>
  </div>
  <!-- 버튼 s -->
  <div class="button-box col2 mt40" v-if="status == 'READY'">
    <button type="button" @click="registRefundAccount" :disabled='isAprrovalDisabled' class="btn lg">승인요청</button>
  </div>
  <!-- 버튼 e -->
</template>
<script lang="ts" setup>
import AccoungManager from '@/components/corner/pc/HconCornerAccountManagerPC.vue'
import HconCheckBox from '@/components/com/HconComPCCheckbox.vue'
import { usePopup } from '@/composables/hconUsePopup'
import { useRoute } from 'vue-router';
import { ref, onMounted, watch } from 'vue'
import type { CodeDto, CommFileDto } from '~/types/common/backend-dto-types';
import { COMMON_CODE, MEMBER_CODE } from '@/constants/hconMessageConstants'

const fetchBuilder        = useHconFetchBuilder();
const checkBoxAgree         = ref("")
const checkBoxAgreeChecked  = ref("N")
const checkBoxAgreeChanged  = (isChecked : boolean) => { checkBoxAgreeChecked.value= isChecked ? 'Y' :'N' }
const bzcoRgcrt = ref<CommonFile[]>([]);
const accountManagerRef            = ref<InstanceType<typeof AccoungManager> | null>();
const fileUploadFlag = ref(false);
const accountCrtfFlag = ref(false);
const status = ref('READY');
const isAprrovalDisabled = ref(true)
// 팝업
const {
  showAlert
} = usePopup()

const accountForm = ref({
  bank: '',
  bankCode : '', 
  accountNumber: '',
  depositor: '',
  identifyNo: '',
  crtfYn : '',
  filePath: '',
  fileName: '',
  acntCrtfYn: '',
  acntCrtfDt : '',
  acntApvYn: '',
  acntApvDt: '',
})

watch(bzcoRgcrt, (newBzcoRgcrt, ) => {
  fileUploadFlag.value = false
  console.log(bzcoRgcrt.value)
  if(cu.isNotEmpty(newBzcoRgcrt[0].id)) fileUploadFlag.value = true;
})

watch(accountForm, (newAccountForm, ) => {
  accountCrtfFlag.value = false;
  if(newAccountForm.crtfYn == 'Y') fileUploadFlag.value = true;
  if(newAccountForm.bankCode != '') {
    isAprrovalDisabled.value = false;
  } else {
    isAprrovalDisabled.value = true;
  }
})
// 환불계좌관리 탭 팝업
const registRefundAccount = async () => {
  if(!accountManagerRef.value?.onFileValidate()) {
    return false;
  }

  if(!accountCrtfFlag.value) {
    showAlert({
      title: '',
      message: HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001, '계좌인증을', '완료'),
      confirmText: '확인'
    })
    return false;
  }

  if(checkBoxAgreeChecked.value =='N') {
    showAlert({
      title: '',
      message: HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001, '개인정보 수집 및 이용에', '동의'),
      confirmText: '확인'
    })
    return false;
  }

  if(fileUploadFlag.value) {
    await uploadBzcoRgcrt();
  } else {
    showAlert({
      title: '',
      message: HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001, '통장사본 업로드를', '완료'),
      confirmText: '확인'
    })
    return false;
  }
}

// 이미지 등록
const uploadBzcoRgcrt = async () => {

// API 호출
const fetchBuilderResult = 
fetchBuilder.post<AjaxResult<CommFileDto>>('/api/v1/common/file-upload')
.body({
    userKey: useHconAuthInfo().getIfPossible()?.userContext.userKey, 
    subject: "account-register",
    store: "private",
    file: bzcoRgcrt.value?.[0] ?? null
  })
.build()
.execute()
.then((result) => {
  if(result.resultCode != '200') {
    showAlert({
      title: '알림',
      message: result.resultMessage,
      confirmText: '확인'
    })

    return false;
  } else {
    // 정상인 경우 - DB처리
    if((result.data.file.id !== null && result.data.file.id.length > 0)
        && (result.data.file.name !== null && result.data.file.name.length > 0)) {
          accountForm.value.fileName = result.data.file.name;
          accountForm.value.filePath = result.data.file.id;


          fetchBuilder
    .post<AjaxResult<any>>("/api/v1/mypage/account/regist-account")
    .body(
      {
        hcUsrAcntKndCd : '1001',
        hcFnnsCd: accountForm.value.bankCode,
        hcEncActno : accountForm.value.accountNumber,
        dpsrNm : accountForm.value.depositor,
        acntCrtfYn : "Y",
        updateFlag : cu.isNotEmpty(accountForm.value.acntCrtfDt) ? 'U' : 'C',
        filePath: accountForm.value.filePath,
        fileName: accountForm.value.fileName,
      }
    )
    .build()
    .execute()
    .then((result) => {
      showAlert({
      title: '환불 계좌 등록 완료',
      message: HconCommonUtils.format.message(MEMBER_CODE.ALT_HCON_9042),
      confirmText: '확인',
      onConfirm: () => {
        window.location.reload()
        }
      })
    });
    } else {
      showAlert({
        title: '알림',
        message: HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9157),
        confirmText: '확인'
      })

      return false;
    }
  }
})
}

const handleCheckAccount = ( result : boolean) => {
  accountCrtfFlag.value = result
};
</script>
<style lang="scss" scoped>
@use "@/assets/scss/pc/order-hcon.scss" as *;
@use "@/assets/scss/pc/mypage-hcon.scss" as *;

</style>